<template>
    <div v-if="fatalError">
        <div class="card-header">Ooops! We seem to be having some technical difficulties.</div>
            <div class="card-body">
                <p class="card-text">Unfortunately our booking system is having a lie down at the moment!</p>
                <p class="card-text">Feel free to give us another try later, or contact us via <a :href="mailTo">email</a> or <a :href="tel">phone</a> instead.</p> 
                <p class="card-text">We'd be delighted to hear from you.</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState({ 
            fatalError: state => state.wizard.fatalError
        }),
        mailTo() { return `mailto:${process.env.VUE_APP_CONTACT_EMAIL}` },
        tel() { return `tel:${process.env.VUE_APP_CONTACT_PHONE}` }
    }
}
</script>